import axios from "../axios";

const createDeposit = async function (data, accessToken) {
    try {
        const response = await axios.post('/deposit/createDeposit', data, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status,
            message: e.response.data.message
        }
    }
}

export default createDeposit; 
